import { render, staticRenderFns } from "./KanbanTile.vue?vue&type=template&id=6ea6bf4e"
import script from "./KanbanTile.vue?vue&type=script&lang=js"
export * from "./KanbanTile.vue?vue&type=script&lang=js"
import style0 from "./KanbanTile.vue?vue&type=style&index=0&id=6ea6bf4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports